export default "__VITE_ASSET__Bwgm_3OG__"